<button *ngIf="enabled" [ngClass]="{'button--login': customStyle == 'login'}" [type]="type" class="button">{{text}}</button>

<button *ngIf="!enabled" [ngClass]="{'button--login': customStyle == 'login'}" class="button button--disabled" disabled>{{text}}</button>
